module.exports = "pegasus/assets/themelp1/travel/104.png";